export default function AssessmentDocumentController(
  $q,
  $rootScope,
  $scope,
  alerts,
  ecatDataService,
  ecatSharedModelService,
  confirmDialog,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  editAssessmentDocumentDialog
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Assessment Document Added';
  vm.isExpanded = false;
  vm.isEditable = true;

  // Attach Event Handlers
  vm.handleEditAssessmentDocument = _handleEditAssessmentDocument;

  vm.handleUnattachAssessmentDocument = _handleUnattachAssessmentDocument;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  function _handleEditAssessmentDocument($event) {
    ecatDataService.getAssessmentDocumentTypes().then((response) => {
      const documentTypes = response.data.result;
      ssDialogService.dialogs.ecat.editDocumentAttachmentDialog = ssDialogService.alert(
        editAssessmentDocumentDialog.getOptions($event, {
          assessment: vm.assessment,
          document: vm.assessmentDocument,
          documentTypes,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.ecat.editDocumentAttachmentDialog);
    });
  }

  function _handleUnattachAssessmentDocument($event) {
    ssDialogService.dialogs.ecat.deleteAssessmentDocumentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Remove Assessment Document?',
        message: `Are you sure you want to remove document "${vm.assessmentDocument.displayName}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.ecat.deleteAssessmentDocumentConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return ecatDataService.detachAssessmentDocument(vm.assessmentDocument.assessmentDocumentId)
      .then(() => {
        alerts.success('The document has been removed successfully.');
        $rootScope.$broadcast('refreshECATAssessmentDocuments', { assessmentId: vm.assessmentDocument.assessmentId });
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('An error occurred while removing the document.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.ecat.deleteAssessmentDocumentConfirmDialog);
  }
}

AssessmentDocumentController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'ecatDataService',
  'ecatSharedModelService',
  'confirmDialog',
  'docDataService',
  'loaderService',
  'orgDataService',
  'ssDialogService',
  'editAssessmentDocumentDialog'
];
